import { z } from "zod";
import { UserTutorialDto } from "./tutorial.ts";

export const OnboardingSurveyAnswerDto = z.object({
  questionId: z.string(),
  answer: z.string(),
});

export const OnboardingSurveyDto = z.object({
  answeredAt: z.string(),
  finished: z.boolean(),
  answers: OnboardingSurveyAnswerDto.array(),
});

export const SubmitOnboardingSurveyDto = z.object({
  finished: z.boolean(),
  answers: OnboardingSurveyAnswerDto.array(),
});

export const UserFlagsDto = z
  .object({
    creativeModeIntroSeen: z.string().optional(),
    dfyLinkSeen: z.string().optional(),
    tutorials: z.array(UserTutorialDto).optional(),
  })
  .strict();

export const SetUserFlagsDto = UserFlagsDto.pick({
  creativeModeIntroSeen: true,
  dfyLinkSeen: true,
});

export const SelfDto = z.object({
  externalId: z.string(),
  contactEmail: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  onboardingSurveyCompleted: z.boolean(),
  onboardingSurveyRole: z.string().nullable(),
  flags: UserFlagsDto,
  teamMemberships: z.array(
    z.object({
      teamExternalId: z.string(),
      teamName: z.string(),
      role: z.string(),
      permissions: z.array(z.string()),
    }),
  ),
});

export const IntercomMessengerPayloadDto = z.object({
  signedPayload: z.string(),
});

export const CreateApiKeyDto = z.object({
  name: z.string().optional(),
});

export const ApiKeyDto = z.object({
  apiKey: z.string(),
});

export const UserRolesDto = z.object({
  roles: z.array(z.string()),
});

export type OnboardingSurveyAnswerDto = z.infer<
  typeof OnboardingSurveyAnswerDto
>;
export type OnboardingSurveyDto = z.infer<typeof OnboardingSurveyDto>;
export type SubmitOnboardingSurveyDto = z.infer<
  typeof SubmitOnboardingSurveyDto
>;
export type SelfDto = z.infer<typeof SelfDto>;
export type IntercomMessengerPayloadDto = z.infer<
  typeof IntercomMessengerPayloadDto
>;
export type CreateApiKeyDto = z.infer<typeof CreateApiKeyDto>;
export type ApiKeyDto = z.infer<typeof ApiKeyDto>;
export type UserRolesDto = z.infer<typeof UserRolesDto>;
export type UserFlagsDto = z.infer<typeof UserFlagsDto>;
export type SetUserFlagsDto = z.infer<typeof SetUserFlagsDto>;
